<template>
	<div class="createFirstChannel">
		<div class="stepClass">
			<el-button type="primary" style="margin-bottom: 16px ;" @click="next">{{active !== 2 ?'下一步':'跳转第一步'}}</el-button>
			<el-steps :active="active" finish-status="success">
				<el-step title="填写基础资料">				
				</el-step>
				<el-step title="填写合规问卷">
				</el-step>
				<el-step title="确认提交">
				</el-step>
			</el-steps>
		</div>
		<br><br>
		<div class="dataFillContainer"  :class="{'dispear':firstVisible}">
		    <el-form :model="formData" :rules="rules" ref="ruleForm">
		    	<div class="headerBox" style="text-align:center"><h3>基础资料</h3></div>
		    	<div class="baseInfoBox">
		            <h3>贵公司基本情况</h3><br>
		            <el-row :gutter="10">
		                <el-col :md="4">法定名称：</el-col>
		                <el-col :md="20">
		                    <el-form-item prop="baseInfo.legalNamelegalName">
		                        <el-input
		                            type="text"
		                            placeholder="法定名称"
		                            v-model="formData.baseInfo.legalNamelegalName">
		                        </el-input>
		                    </el-form-item>
		                </el-col>
		            </el-row>
		            <el-row :gutter="10">
		                <el-col :md="4">业绩核算城市：</el-col>
		                <el-col :md="20">
		                    <el-form-item prop="baseInfo.performanceAccountingProvince">
		                        <el-select v-model="formData.baseInfo.performanceAccountingProvince" 
		                                   @change="performanceAccountingProvinceChange"
		                                   placeholder="省">
		                        <el-option
		                            v-for="item in regions"
		                            :key="item.id"
		                            :label="item.name"
		                            :value="item.name">
		                            </el-option>
		                        </el-select>
		                    </el-form-item>
		                    <el-form-item prop="baseInfo.performanceAccountingCity">
		                        <el-select v-model="formData.baseInfo.performanceAccountingCity" placeholder="市">
		                        <el-option
		                            v-for="item in performanceAccountingCitySecondRegions"
		                            :key="item.id"
		                            :label="item.name"
		                            :value="item.name">
		                            </el-option>
		                        </el-select>
		                    </el-form-item>
		                </el-col>
		            </el-row>
		            <el-row :gutter="10">
		                <el-col :md="4">注册资金(万元RMB)：</el-col>
		                <el-col :md="20">
		                    <el-form-item prop="baseInfo.registeredCapital">
		                        <el-input
		                            type="text"
		                            placeholder="注册资金(万元RMB)"
		                            v-model="formData.baseInfo.registeredCapital">
		                        </el-input>
		                    </el-form-item>
		                </el-col>
		            </el-row>
		            <el-row :gutter="10">
		                <el-col :md="4">成立时间：</el-col>
		                <el-col :md="20">
		                    <el-form-item prop="baseInfo.establishmentTime">
		                        <el-date-picker
		                            v-model="formData.baseInfo.establishmentTime"
		                            type="datetime"
		                            placeholder="成立时间">
		                        </el-date-picker>
		                    </el-form-item>
		                </el-col>
		            </el-row>
		            <el-row :gutter="10">
		                <el-col :md="4">税务登记号：</el-col>
		                <el-col :md="20">
		                    <el-form-item prop="baseInfo.taxID">
		                        <el-input
		                            type="text"
		                            placeholder="税务登记号 "
		                            v-model="formData.baseInfo.taxID">
		                        </el-input>
		                    </el-form-item>
		                </el-col>
		            </el-row>
		            <el-row :gutter="10">
		                <el-col :md="4">申请时间：</el-col>
		                <el-col :md="20">
		                    <el-form-item prop="baseInfo.applicationTime">
		                        <el-date-picker
		                            v-model="formData.baseInfo.applicationTime"
		                            type="datetime"
		                            placeholder="申请时间">
		                        </el-date-picker>
		                    </el-form-item>
		                </el-col>
		            </el-row>
		            <el-row :gutter="10">
		                <el-col :md="4">纳税人类别：</el-col>
		                <el-col :md="20">
		                    <el-form-item prop="baseInfo.taxpayerType">
		                        <el-select v-model="formData.baseInfo.taxpayerType" placeholder="纳税人类别">
		                        <el-option
		                            v-for="item in taxpayerTypeList"
									:key="item"
		                            :label="item"
		                            :value="item">
		                            </el-option>
		                        </el-select>
		                    </el-form-item>
		                </el-col>
		            </el-row>
		            <el-row :gutter="10">
		                <el-col :md="4">信产部系统集成商资质：</el-col>
		                <el-col :md="20">
		                    <el-form-item prop="baseInfo.integrateQualifications">
		                        <el-select v-model="formData.baseInfo.integrateQualifications" placeholder="信产部系统集成商资质">
		                        <el-option
		                            v-for="item in integrateQualificationsList"
									:key="item"
		                            :label="item"
		                            :value="item">
		                            </el-option>
		                        </el-select>
		                    </el-form-item>
		                </el-col>
		            </el-row>
		            <el-row :gutter="10">
		                <el-col :md="4">所在省份：</el-col>
		                <el-col :md="20">
		                    <el-form-item prop="baseInfo.currentProvice">
		                        <el-select v-model="formData.baseInfo.currentProvice" placeholder="所在省份">
		                        <el-option
		                            v-for="item in regions"
		                            :key="item.id"
		                            :label="item.name"
		                            :value="item.name">
		                            </el-option>
		                        </el-select>
		                    </el-form-item>
		                </el-col>
		            </el-row>
		            <el-row :gutter="10">
		                <el-col :md="4"> 所属办事处：</el-col>
		                <el-col :md="20">
		                    <el-form-item prop="baseInfo.subordinateOffices">
		                        <el-select v-model="formData.baseInfo.subordinateOffices" placeholder=" 所属办事处">
		                        <el-option
		                            v-for="item in subordinateOfficesList"
									:key="item"
		                            :label="item"
		                            :value="item">
		                            </el-option>
		                        </el-select>
		                    </el-form-item>
		                </el-col>
		            </el-row>
		            <el-row :gutter="10">
		                <el-col :md="4">总机：</el-col>
		                <el-col :md="20">
		                    <el-form-item prop="baseInfo.switchboard">
		                        <el-input
		                            type="text"
		                            placeholder="总机"
		                            v-model="formData.baseInfo.switchboard">
		                        </el-input>
		                    </el-form-item>
		                </el-col>
		            </el-row>
		            <el-row :gutter="10">
		                <el-col :md="4">传真：</el-col>
		                <el-col :md="20">
		                    <el-form-item prop="baseInfo.fax">
		                        <el-input
		                            type="text"
		                            placeholder="传真"
		                            v-model="formData.baseInfo.fax">
		                        </el-input>
		                    </el-form-item>
		                </el-col>
		            </el-row>
		            <el-row :gutter="10">
		                <el-col :md="4">邮编：</el-col>
		                <el-col :md="20">
		                    <el-form-item prop="baseInfo.zipCode">
		                        <el-input
		                            type="text"
		                            placeholder="邮编"
		                            v-model="formData.baseInfo.zipCode">
		                        </el-input>
		                    </el-form-item>
		                </el-col>
		            </el-row>
		            <el-row :gutter="10">
		                <el-col :md="4">邮寄地址：</el-col>
		                <el-col :md="20">
		                    <el-form-item prop="baseInfo.mailingAddress">
		                        <el-input
		                            type="text"
		                            placeholder="邮寄地址"
		                            v-model="formData.baseInfo.mailingAddress">
		                        </el-input>
		                    </el-form-item>
		                </el-col>
		            </el-row>
		            <el-row :gutter="10">
		                <el-col :md="4">网址：</el-col>
		                <el-col :md="20">
		                    <el-input
		                        type="text"
		                        placeholder="网址"
		                        v-model="formData.baseInfo.webAddress">
		                    </el-input>
		                </el-col>
		            </el-row>
		            <el-row :gutter="10">
		                <el-col :md="4">业务介绍： </el-col>
		                <el-col :md="20">
		                    <el-input type="textarea" v-model="formData.baseInfo.businessIntroduction"></el-input>
		                </el-col>
		            </el-row>
		        </div>
		        <div class="contactInfoBox">
		            <h3>贵公司基本联络信息</h3><br>
		            <el-row :gutter="10">
		                <el-col :md="4">职务 </el-col>
		                <el-col :md="8">姓名 </el-col>
		                <el-col :md="4">电话 </el-col>
		                <el-col :md="4">手机 </el-col>
		                <el-col :md="4">Email </el-col>
		            </el-row>
		            <el-row :gutter="10">
		                <el-col :md="4">法人代表：</el-col>
		                <el-col :md="8">
		                    <el-form-item prop="contactInfo.corporateRepresentative.name">
		                        <el-input
		                            type="text"
		                            placeholder="姓名"
		                            v-model="formData.contactInfo.corporateRepresentative.name">
		                        </el-input>
		                    </el-form-item>
		                </el-col>
		                <el-col :md="4">
		                    <el-form-item prop="contactInfo.corporateRepresentative.phone">
		                        <el-input
		                            type="text"
		                            placeholder="电话"
		                            v-model="formData.contactInfo.corporateRepresentative.phone">
		                        </el-input>
		                    </el-form-item>
		                </el-col>
		                <el-col :md="4">
		                    <el-form-item prop="contactInfo.corporateRepresentative.tel">
		                        <el-input
		                            type="text"
		                            placeholder="手机"
		                            v-model="formData.contactInfo.corporateRepresentative.tel">
		                        </el-input>
		                    </el-form-item>
		                </el-col>
		                <el-col :md="4">
		                    <el-form-item prop="contactInfo.corporateRepresentative.email">
		                        <el-input
		                            type="text"
		                            placeholder="Email"
		                            v-model="formData.contactInfo.corporateRepresentative.email">
		                        </el-input>
		                    </el-form-item>
		                </el-col>
		            </el-row>
		            <el-row :gutter="10">
		                <el-col :md="4">总经理：</el-col>
		                <el-col :md="8">
		                    <el-form-item prop="contactInfo.generalManager.name">
		                        <el-input
		                            type="text"
		                            placeholder="姓名"
		                            v-model="formData.contactInfo.generalManager.name">
		                        </el-input>
		                    </el-form-item>
		                </el-col>
		                <el-col :md="4">
		                    <el-form-item prop="contactInfo.generalManager.phone">
		                        <el-input
		                            type="text"
		                            placeholder="电话"
		                            v-model="formData.contactInfo.generalManager.phone">
		                        </el-input>
		                    </el-form-item>
		                </el-col>
		                <el-col :md="4">
		                    <el-form-item prop="contactInfo.generalManager.tel">
		                        <el-input
		                            type="text"
		                            placeholder="手机"
		                            v-model="formData.contactInfo.generalManager.tel">
		                        </el-input>
		                    </el-form-item>
		                </el-col>
		                <el-col :md="4">
		                    <el-form-item prop="contactInfo.generalManager.email">
		                        <el-input
		                            type="text"
		                            placeholder="Email"
		                            v-model="formData.contactInfo.generalManager.email">
		                        </el-input>
		                    </el-form-item>
		                </el-col>
		            </el-row>
		            <br>
		            <hr>
		            <br>
		            <el-row :gutter="10">
		                <el-col :md="4">紫光华智产品负责人 </el-col>
		                <el-col :md="4">职务 </el-col>
		                <el-col :md="4">姓名 </el-col>
		                <el-col :md="4">电话 </el-col>
		                <el-col :md="4">手机 </el-col>
		                <el-col :md="4">Email </el-col>
		            </el-row>
		            <el-row :gutter="10">
		                <el-col :md="4">销售负责人：</el-col>
		                <el-col :md="4">
		                    <el-form-item prop="contactInfo.salesPersonInCharge.job">
		                        <el-input
		                            type="text"
		                            placeholder="职务"
		                            v-model="formData.contactInfo.salesPersonInCharge.job">
		                        </el-input>
		                    </el-form-item>
		                </el-col>
		                <el-col :md="4">
		                    <el-form-item prop="contactInfo.salesPersonInCharge.name">
		                        <el-input
		                            type="text"
		                            placeholder="姓名"
		                            v-model="formData.contactInfo.salesPersonInCharge.name">
		                        </el-input>
		                    </el-form-item>
		                </el-col>
		                <el-col :md="4">
		                    <el-form-item prop="contactInfo.salesPersonInCharge.phone">
		                        <el-input
		                            type="text"
		                            placeholder="电话"
		                            v-model="formData.contactInfo.salesPersonInCharge.phone">
		                        </el-input>
		                    </el-form-item>
		                </el-col>
		                <el-col :md="4">
		                    <el-form-item prop="contactInfo.salesPersonInCharge.tel">
		                        <el-input
		                            type="text"
		                            placeholder="手机"
		                            v-model="formData.contactInfo.salesPersonInCharge.tel">
		                        </el-input>
		                    </el-form-item>
		                </el-col>
		                <el-col :md="4">
		                    <el-form-item prop="contactInfo.salesPersonInCharge.email">
		                        <el-input
		                            type="text"
		                            placeholder="Email"
		                            v-model="formData.contactInfo.salesPersonInCharge.email">
		                        </el-input>
		                    </el-form-item>
		                </el-col>
		            </el-row>
		            <!-- <el-row :gutter="10">
		                <el-col :md="4">宣传负责人： </el-col>
		                <el-col :md="4">
		                    <el-form-item prop="contactInfo.publicityOfficer.job">
		                        <el-input
		                            type="text"
		                            placeholder="职务"
		                            v-model="formData.contactInfo.publicityOfficer.job">
		                        </el-input>
		                    </el-form-item>
		                </el-col>
		                <el-col :md="4">
		                    <el-form-item prop="contactInfo.publicityOfficer.name">
		                        <el-input
		                            type="text"
		                            placeholder="姓名"
		                            v-model="formData.contactInfo.publicityOfficer.name">
		                        </el-input>
		                    </el-form-item>
		                </el-col>
		                <el-col :md="4">
		                    <el-form-item prop="contactInfo.publicityOfficer.phone">
		                        <el-input
		                            type="text"
		                            placeholder="电话"
		                            v-model="formData.contactInfo.publicityOfficer.phone">
		                        </el-input>
		                    </el-form-item>
		                </el-col>
		                <el-col :md="4">
		                    <el-form-item prop="contactInfo.publicityOfficer.tel">
		                        <el-input
		                            type="text"
		                            placeholder="手机"
		                            v-model="formData.contactInfo.publicityOfficer.tel">
		                        </el-input>
		                    </el-form-item>
		                </el-col>
		                <el-col :md="4">
		                    <el-form-item prop="contactInfo.publicityOfficer.email">
		                        <el-input
		                            type="text"
		                            placeholder="Email"
		                            v-model="formData.contactInfo.publicityOfficer.email">
		                        </el-input>
		                    </el-form-item>
		                </el-col>
		            </el-row> -->
		            <el-row :gutter="10">
		                <el-col :md="4">商务负责人： </el-col>
		                <el-col :md="4">
		                    <el-form-item prop="contactInfo.businessPersonInCharge.job">
		                        <el-input
		                            type="text"
		                            placeholder="职务"
		                            v-model="formData.contactInfo.businessPersonInCharge.job">
		                        </el-input>
		                    </el-form-item>
		                </el-col>
		                <el-col :md="4">
		                    <el-form-item prop="contactInfo.businessPersonInCharge.name">
		                        <el-input
		                            type="text"
		                            placeholder="姓名"
		                            v-model="formData.contactInfo.businessPersonInCharge.name">
		                        </el-input>
		                    </el-form-item>
		                </el-col>
		                <el-col :md="4">
		                    <el-form-item prop="contactInfo.businessPersonInCharge.phone">
		                        <el-input
		                            type="text"
		                            placeholder="电话"
		                            v-model="formData.contactInfo.businessPersonInCharge.phone">
		                        </el-input>
		                    </el-form-item>
		                </el-col>
		                <el-col :md="4">
		                    <el-form-item prop="contactInfo.businessPersonInCharge.tel">
		                        <el-input
		                            type="text"
		                            placeholder="手机"
		                            v-model="formData.contactInfo.businessPersonInCharge.tel">
		                        </el-input>
		                    </el-form-item>
		                </el-col>
		                <el-col :md="4">
		                    <el-form-item prop="contactInfo.businessPersonInCharge.email">
		                        <el-input
		                            type="text"
		                            placeholder="Email"
		                            v-model="formData.contactInfo.businessPersonInCharge.email">
		                        </el-input>
		                    </el-form-item>
		                </el-col>
		            </el-row>
		            <el-row :gutter="10">
		                <el-col :md="4">工程负责人: </el-col>
		                <el-col :md="4">
		                    <el-form-item prop="contactInfo.technicalClothingPersonInCharge.job">
		                        <el-input
		                            type="text"
		                            placeholder="职务"
		                            v-model="formData.contactInfo.technicalClothingPersonInCharge.job">
		                        </el-input>
		                    </el-form-item>
		                </el-col>
		                <el-col :md="4">
		                    <el-form-item prop="contactInfo.technicalClothingPersonInCharge.name">
		                        <el-input
		                            type="text"
		                            placeholder="姓名"
		                            v-model="formData.contactInfo.technicalClothingPersonInCharge.name">
		                        </el-input>
		                    </el-form-item>
		                </el-col>
		                <el-col :md="4">
		                    <el-form-item prop="contactInfo.technicalClothingPersonInCharge.phone">
		                        <el-input
		                            type="text"
		                            placeholder="电话"
		                            v-model="formData.contactInfo.technicalClothingPersonInCharge.phone">
		                        </el-input>
		                    </el-form-item>
		                </el-col>
		                <el-col :md="4">
		                    <el-form-item prop="contactInfo.technicalClothingPersonInCharge.tel">
		                        <el-input
		                            type="text"
		                            placeholder="手机"
		                            v-model="formData.contactInfo.technicalClothingPersonInCharge.tel">
		                        </el-input>
		                    </el-form-item>
		                </el-col>
		                <el-col :md="4">
		                    <el-form-item prop="contactInfo.technicalClothingPersonInCharge.email">
		                        <el-input
		                            type="text"
		                            placeholder="Email"
		                            v-model="formData.contactInfo.technicalClothingPersonInCharge.email">
		                        </el-input>
		                    </el-form-item>
		                </el-col>
		            </el-row>
		            <el-row :gutter="10">
		                <el-col :md="4">订单通知单接收人: </el-col>
		                <el-col :md="4">
		                    <el-form-item prop="contactInfo.orderNotificationReceiver.job">
		                        <el-input
		                            type="text"
		                            placeholder="职务"
		                            v-model="formData.contactInfo.orderNotificationReceiver.job">
		                        </el-input>
		                    </el-form-item>
		                </el-col>
		                <el-col :md="4">
		                    <el-form-item prop="contactInfo.orderNotificationReceiver.name">
		                        <el-input
		                            type="text"
		                            placeholder="姓名"
		                            v-model="formData.contactInfo.orderNotificationReceiver.name">
		                        </el-input>
		                    </el-form-item>
		                </el-col>
		                <el-col :md="4">
		                    <el-form-item prop="contactInfo.orderNotificationReceiver.phone">
		                        <el-input
		                            type="text"
		                            placeholder="电话"
		                            v-model="formData.contactInfo.orderNotificationReceiver.phone">
		                        </el-input>
		                    </el-form-item>
		                </el-col>
		                <el-col :md="4">
		                    <el-form-item prop="contactInfo.orderNotificationReceiver.tel">
		                        <el-input
		                            type="text"
		                            placeholder="手机"
		                            v-model="formData.contactInfo.orderNotificationReceiver.tel">
		                        </el-input>
		                    </el-form-item>
		                </el-col>
		                <el-col :md="4">
		                    <el-form-item prop="contactInfo.orderNotificationReceiver.email">
		                        <el-input
		                            type="text"
		                            placeholder="Email"
		                            v-model="formData.contactInfo.orderNotificationReceiver.email">
		                        </el-input>
		                    </el-form-item>
		                </el-col>
		            </el-row>
		            <el-row :gutter="10">
		                <el-col :md="4">日常联络人: </el-col>
		                <el-col :md="4">
		                    <el-form-item prop="contactInfo.dailyContactPerson.job">
		                        <el-input
		                            type="text"
		                            placeholder="职务"
		                            v-model="formData.contactInfo.dailyContactPerson.job">
		                        </el-input>
		                    </el-form-item>
		                </el-col>
		                <el-col :md="4">
		                    <el-form-item prop="contactInfo.dailyContactPerson.name">
		                        <el-input
		                            type="text"
		                            placeholder="姓名"
		                            v-model="formData.contactInfo.dailyContactPerson.name">
		                        </el-input>
		                    </el-form-item>
		                </el-col>
		                <el-col :md="4">
		                    <el-form-item prop="contactInfo.dailyContactPerson.phone">
		                        <el-input
		                            type="text"
		                            placeholder="电话"
		                            v-model="formData.contactInfo.dailyContactPerson.phone">
		                        </el-input>
		                    </el-form-item>
		                </el-col>
		                <el-col :md="4">
		                    <el-form-item prop="contactInfo.dailyContactPerson.tel">
		                        <el-input
		                            type="text"
		                            placeholder="手机"
		                            v-model="formData.contactInfo.dailyContactPerson.tel">
		                        </el-input>
		                    </el-form-item>
		                </el-col>
		                <el-col :md="4">
		                    <el-form-item prop="contactInfo.dailyContactPerson.email">
		                        <el-input
		                            type="text"
		                            placeholder="Email"
		                            v-model="formData.contactInfo.dailyContactPerson.email">
		                        </el-input>
		                    </el-form-item>
		                </el-col>
		            </el-row>
		        </div>
		        <div class="h3cContactInfoBox">
		            <h3>紫光华智负责与贵公司联系的员工(紫光华智拓展人) </h3><br>
		            <el-row :gutter="10">
		                <el-col :md="8">办事处</el-col>
		                <el-col :md="4">姓名 </el-col>
		                <el-col :md="4">电话 </el-col>
		                <el-col :md="4">手机 </el-col>
		                <el-col :md="4">Email </el-col>
		            </el-row>
		            <el-row :gutter="10">
		                <el-col :md="8">
		                    <el-form-item prop="h3cContactInfo.office">
		                        <el-select v-model="formData.h3cContactInfo.office" style="width:100%" placeholder="省">
		                        <el-option
		                            v-for="item in regions"
		                            :key="item.id"
		                            :label="item.name"
		                            :value="item.name">
		                            </el-option>
		                        </el-select>
		                    </el-form-item>
		                </el-col>
		                <el-col :md="4">
		                    <el-form-item prop="h3cContactInfo.name">
		                        <el-input
		                            type="text"
		                            placeholder="姓名"
		                            v-model="formData.h3cContactInfo.name">
		                        </el-input>
		                    </el-form-item>
		                </el-col>
		                <el-col :md="4">
		                    <el-form-item prop="h3cContactInfo.phone">
		                        <el-input
		                            type="text"
		                            placeholder="电话"
		                            v-model="formData.h3cContactInfo.phone">
		                        </el-input>
		                    </el-form-item>
		                </el-col>
		                <el-col :md="4">
		                    <el-form-item prop="h3cContactInfo.tel">
		                        <el-input
		                            type="text"
		                            placeholder="手机"
		                            v-model="formData.h3cContactInfo.tel">
		                        </el-input>
		                    </el-form-item>
		                </el-col>
		                <el-col :md="4">
		                    <el-form-item prop="h3cContactInfo.email">
		                        <el-input
		                            type="text"
		                            placeholder="Email"
		                            v-model="formData.h3cContactInfo.email">
		                        </el-input>
		                    </el-form-item>
		                </el-col>
		            </el-row>
		        </div>
		        <div class="fileUploadInfoBox">
		            <h3>上传申请认证资料</h3>
		            <h6>请贵公司提交资质文件，包括以下几部分:（如果是非原始扫描件，请在复印件上加盖公章。单个附件大小请控制在200K以内，转化请参考帮助文档。带*为必需）</h6><br>
		            <el-row :gutter="10">
		                <el-col :md="4">营业执照： </el-col>
		                <el-col :md="20">
		                    <el-upload
		                        style="width: 360px;"
		                        :action="fileUploadWeb+'?type=businessLicense'"
		                        :with-credentials="true"
		                        multiple
		                        :limit="1"
		                        :on-success="fileUploadBus">
		                        <el-button size="small" type="primary">点击上传</el-button>
		                        <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>
		                    </el-upload>
		                </el-col>
		            </el-row>
		            <el-row :gutter="10">
		                <el-col :md="4">银行开户许可证： </el-col>
		                <el-col :md="20">
		                    <el-upload
		                        style="width: 360px;"
		                        :action="fileUploadWeb+'?type=openBankAccountPermitCertificate'"
		                        :with-credentials="true"
		                        multiple
		                        :limit="1"
		                        :on-success="fileUploadOpe">
		                        <el-button size="small" type="primary">点击上传</el-button>
		                        <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>
		                    </el-upload>
		                </el-col>
		            </el-row>
		            <el-row :gutter="10">
		                <el-col :md="4">法人身份证复印件(正反面)：</el-col>
		                <el-col :md="20">
		                    <el-upload
		                        style="width: 360px;"
		                        :action="fileUploadWeb+'?type=copyOfIDCard'"
		                        :with-credentials="true"
		                        multiple
		                        :limit="1"
		                        :on-success="fileUploadCop">
		                        <el-button size="small" type="primary">点击上传</el-button>
		                        <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>
		                    </el-upload>
		                </el-col>
		            </el-row>
		            <el-row :gutter="10">
		                <el-col :md="4">信产部系统集成资质证书：</el-col>
		                <el-col :md="20">
		                    <el-upload
		                        style="width: 360px;"
		                        :action="fileUploadWeb+'?type=integratedQualificationCertificate'"
		                        :with-credentials="true"
		                        multiple
		                        :limit="1"
		                        :on-success="fileUploadInt">
		                        <el-button size="small" type="primary">点击上传</el-button>
		                        <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>
		                    </el-upload>
		                </el-col>
		            </el-row>
		            <el-row :gutter="10">
		                <el-col :md="4">验资报告或财务审计报告：</el-col>
		                <el-col :md="20">
		                    <el-upload
		                        style="width: 360px;"
		                        :action="fileUploadWeb+'?type=capitalVerificationReport'"
		                        :with-credentials="true"
		                        multiple
		                        :limit="1"
		                        :on-success="fileUploadCap">
		                        <el-button size="small" type="primary">点击上传</el-button>
		                        <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>
		                    </el-upload>
		                </el-col>
		            </el-row>
		            <el-row :gutter="10">
		                <el-col :md="4">其它(如果多个,请打包成一个):</el-col>
		                <el-col :md="20">
		                    <el-upload
		                        style="width: 360px;"
		                        :action="fileUploadWeb+'?type=others'"
		                        :with-credentials="true"
		                        multiple
		                        :limit="1"
		                        :on-success="fileUploadOth">
		                        <el-button size="small" type="primary">点击上传</el-button>
		                        <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>
		                    </el-upload>
		                </el-col>
		            </el-row>
		        </div>
		        <br>
		    </el-form>
	    </div>
	    <div class="questionnaireContainer" :class="{'dispear':secondeVisible}">
	        <div  class="headerBox" style="text-align:center"><h3>合规问卷</h3></div>
	        <div class="contentBox">
	            <el-form :model="data" :rules="qRules" ref="qRuleForm">
	                <div class="companyBaseInfoBox">
	                    <h5>企业基本情况</h5><br>
	                    <el-row :gutter="10">
	                        <el-col :md="8">公司名称：</el-col>
	                        <el-col :md="16">
	                            <el-form-item prop="companyBaseInfo.corporateName">
	                                <el-input
	                                    v-model="data.companyBaseInfo.corporateName"
	                                    type="text"
	                                    placeholder="公司名称">
	                                </el-input>
	                            </el-form-item>
	                        </el-col>
	                    </el-row>
	                    <el-row :gutter="10">
	                        <el-col :md="8">统一社会信用代码：</el-col>
	                        <el-col :md="16">
	                            <el-form-item prop="companyBaseInfo.unifiedSocialCreditCode">
	                                <el-input
	                                    v-model="data.companyBaseInfo.unifiedSocialCreditCode"
	                                    type="text"
	                                    placeholder="统一社会信用代码">
	                                </el-input>
	                            </el-form-item>
	                        </el-col>
	                    </el-row>
	                    <el-row :gutter="10">
	                        <el-col :md="8">注册地址：</el-col>
	                        <el-col :md="16">
	                            <el-form-item prop="companyBaseInfo.registeredAddress">
	                                <el-input
	                                    v-model="data.companyBaseInfo.registeredAddress"
	                                    type="text"
	                                    placeholder="注册地址">
	                                </el-input>
	                            </el-form-item>
	                        </el-col>
	                    </el-row>
	                    <el-row :gutter="10">
	                        <el-col :md="8">实际经营地址：</el-col>
	                        <el-col :md="16">
	                            <el-form-item prop="companyBaseInfo.actualBusinessAddress">
	                                <el-input
	                                    v-model="data.companyBaseInfo.actualBusinessAddress"
	                                    type="text"
	                                    placeholder="实际经营地址">
	                                </el-input>
	                            </el-form-item>
	                        </el-col>
	                    </el-row>
	                    <el-row :gutter="10">
	                        <el-col :md="8">公司官网地址：</el-col>
	                        <el-col :md="16">
	                            <el-form-item prop="companyBaseInfo.companyOfficialWebsiteAddress">
	                                <el-input
	                                    v-model="data.companyBaseInfo.companyOfficialWebsiteAddress"
	                                    type="text"
	                                    placeholder="公司官网地址">
	                                </el-input>
	                            </el-form-item>
	                        </el-col>
	                    </el-row>
	                    <el-row :gutter="10">
	                        <el-col :md="8">法定代表人（姓名+联系电话）：</el-col>
	                        <el-col :md="16">
	                            <el-form-item prop="companyBaseInfo.legalRepresentative">
	                                <el-input
	                                    v-model="data.companyBaseInfo.legalRepresentative"
	                                    type="text"
	                                    placeholder="法定代表人（姓名+联系电话）">
	                                </el-input>
	                            </el-form-item>
	                        </el-col>
	                    </el-row>
	                    <el-row :gutter="10">
	                        <el-col :md="8">总经理（姓名+联系电话）：</el-col>
	                        <el-col :md="16">
	                            <el-form-item prop="companyBaseInfo.generalManager">
	                                <el-input
	                                    v-model="data.companyBaseInfo.generalManager"
	                                    type="text"
	                                    placeholder="总经理（姓名+联系电话）">
	                                </el-input>
	                            </el-form-item>
	                        </el-col>
	                    </el-row>
	                    <el-row :gutter="10">
	                        <el-col :md="8">销售总监（姓名+联系电话）：</el-col>
	                        <el-col :md="16">
	                            <el-form-item prop="companyBaseInfo.salesDirector">
	                                <el-input
	                                    v-model="data.companyBaseInfo.salesDirector"
	                                    type="text"
	                                    placeholder="销售总监（姓名+联系电话）">
	                                </el-input>
	                            </el-form-item>
	                        </el-col>
	                    </el-row>
	                    <el-row :gutter="10">
	                        <el-col :md="8">其他主要管理人员（请注明职务+姓名+联系电话）：</el-col>
	                        <el-col :md="16">
	                            <el-form-item prop="companyBaseInfo.OtherKeyManagers">
	                                <el-input type="textarea"
	                                    v-model="data.companyBaseInfo.OtherKeyManagers" ></el-input>
	                            </el-form-item>
	                        </el-col>
	                    </el-row>
	                </div>
	                <hr><br>
	                <div class="companyBaseInfoBox">
	                    <h5>劳动用工合规</h5><br>
	                    <el-row :gutter="10">
	                        <el-col :md="8">职工总人数：</el-col>
	                        <el-col :md="16">
	                            <el-form-item prop="laborCompliance.totalNumberOfEmployees">
	                                <el-input
	                                    v-model="data.laborCompliance.totalNumberOfEmployees"
	                                    type="text"
	                                    placeholder="职工总人数">
	                                </el-input>
	                            </el-form-item>
	                        </el-col>
	                    </el-row>
	                    <el-row :gutter="10">
	                        <el-col :md="8">劳动用工中是否有童工：</el-col>
	                        <el-col :md="16">
	                            <el-form-item prop="laborCompliance.childLabourExists">
	                                <el-radio v-model="data.laborCompliance.childLabourExists" label="1">是</el-radio>
	                                <el-radio v-model="data.laborCompliance.childLabourExists" label="2">否</el-radio>
	                            </el-form-item>
	                        </el-col>
	                    </el-row>
	                    <el-row :gutter="10">
	                        <el-col :md="8">是否为所有职工购买了社会保险：</el-col>
	                        <el-col :md="16">
	                            <el-form-item prop="laborCompliance.buyingSocialInsurance">
	                                <el-radio v-model="data.laborCompliance.buyingSocialInsurance" label="1">是</el-radio>
	                                <el-radio v-model="data.laborCompliance.buyingSocialInsurance" label="2">否</el-radio>
	                            </el-form-item>
	                        </el-col>
	                    </el-row>
	                    <el-row :gutter="10">
	                        <el-col :md="8">是否违法强制职工加班：</el-col>
	                        <el-col :md="16">
	                            <el-form-item prop="laborCompliance.mandatoryOvertimeWork">
	                                <el-radio v-model="data.laborCompliance.mandatoryOvertimeWork" label="1">是</el-radio>
	                                <el-radio v-model="data.laborCompliance.mandatoryOvertimeWork" label="2">否</el-radio>
	                            </el-form-item>
	                        </el-col>
	                    </el-row>
	                    <el-row :gutter="10">
	                        <el-col :md="8">是否存在剥夺职工合法权利、拖欠工资、侵犯人权等现象：</el-col>
	                        <el-col :md="16">
	                            <el-form-item prop="laborCompliance.deprivationOfStaff">
	                                <el-radio v-model="data.laborCompliance.deprivationOfStaff" label="1">是</el-radio>
	                                <el-radio v-model="data.laborCompliance.deprivationOfStaff" label="2">否</el-radio>
	                            </el-form-item>
	                        </el-col>
	                    </el-row>
	                </div><hr><br>
	                <div class="companyBaseInfoBox">
	                    <h5>公司销售合规</h5><br>
	                    <el-row :gutter="10">
	                        <el-col :md="8">公司销售区域：</el-col>
	                        <el-col :md="16">
	                            <el-form-item prop="companySalesCompliance.companySalesArea">
	                                <el-radio v-model="data.companySalesCompliance.companySalesArea" label="1">大陆地区 </el-radio>
	                                <el-radio v-model="data.companySalesCompliance.companySalesArea" label="2">港澳台地区</el-radio>
	                                <el-radio v-model="data.companySalesCompliance.companySalesArea" label="3">海外地区</el-radio>
	                            </el-form-item>
	                        </el-col>
	                    </el-row>
	                    <el-row :gutter="10">
	                        <el-col :md="8">销售人员总人数及销售组织架构情况简介：</el-col>
	                        <el-col :md="16">
	                            <el-form-item prop="companySalesCompliance.salesBrief">
	                                <el-input type="textarea" 
	                                v-model="data.companySalesCompliance.salesBrief"></el-input>
	                            </el-form-item>
	                        </el-col>
	                    </el-row>
	                    <el-row :gutter="10">
	                        <el-col :md="20">公司是否根据其当地法律进行组织并经营的？</el-col>
	                        <el-col :md="4">
	                            <el-form-item prop="companySalesCompliance.isTheCompanyLegal">
	                                <el-radio v-model="data.companySalesCompliance.isTheCompanyLegal" label="1">是</el-radio>
	                                <el-radio v-model="data.companySalesCompliance.isTheCompanyLegal" label="2">否</el-radio>
	                            </el-form-item>
	                        </el-col>
	                    </el-row>
	                    <el-row :gutter="10">
	                        <el-col :md="20">公司是否有资质及证明能在指定地点进行商业活动？</el-col>
	                        <el-col :md="4">
	                            <el-form-item prop="companySalesCompliance.isTheCompanyQualified">
	                                <el-radio v-model="data.companySalesCompliance.isTheCompanyQualified" label="1">是</el-radio>
	                                <el-radio v-model="data.companySalesCompliance.isTheCompanyQualified" label="2">否</el-radio>
	                            </el-form-item>
	                        </el-col>
	                    </el-row>
	                    <el-row :gutter="10">
	                        <el-col :md="20">公司是否已获取所有营销紫光华智产品及服务所需的政府许可、执照和登记？</el-col>
	                        <el-col :md="4">
	                            <el-form-item prop="companySalesCompliance.isTheCompanyLicense">
	                                <el-radio v-model="data.companySalesCompliance.isTheCompanyLicense" label="1">是</el-radio>
	                                <el-radio v-model="data.companySalesCompliance.isTheCompanyLicense" label="2">否</el-radio>
	                            </el-form-item>
	                        </el-col>
	                    </el-row>
	                    <el-row :gutter="10">
	                        <el-col :md="20">贵公司是否计划使用次级代理来销售紫光华智的产品和服务？（若是，请在备注栏提供次级渠道商名单）</el-col>
	                        <el-col :md="4">
	                            <el-form-item prop="companySalesCompliance.secondaryAgency">
	                                <el-radio v-model="data.companySalesCompliance.secondaryAgency" label="1">是</el-radio>
	                                <el-radio v-model="data.companySalesCompliance.secondaryAgency" label="2">否</el-radio>
	                            </el-form-item>
	                        </el-col>
	                    </el-row>
	                </div><hr><br>
	                <div class="companyBaseInfoBox">
	                    <h5>企业反腐败合规、道德合规</h5><br>
	                    <el-row :gutter="10">
	                        <el-col :md="20">公司最近五年是否存在商业贿赂行为？</el-col>
	                        <el-col :md="4">
	                            <el-form-item prop="moralCompliance.commercialBribery">
	                                <el-radio v-model="data.moralCompliance.commercialBribery" label="1">是</el-radio>
	                                <el-radio v-model="data.moralCompliance.commercialBribery" label="2">否</el-radio>
	                            </el-form-item>
	                        </el-col>
	                    </el-row>
	                    <el-row :gutter="10">
	                        <el-col :md="20">公司最近五年是否有不廉洁、腐败现象？</el-col>
	                        <el-col :md="4">
	                            <el-form-item prop="moralCompliance.corruptionPhenomenon">
	                                <el-radio v-model="data.moralCompliance.corruptionPhenomenon" label="1">是</el-radio>
	                                <el-radio v-model="data.moralCompliance.corruptionPhenomenon" label="2">否</el-radio>
	                            </el-form-item>
	                        </el-col>
	                    </el-row>
	                    <el-row :gutter="10">
	                        <el-col :md="20">公司对所有销售紫光华智产品及提供相关服务的公司进行反腐败培训，并对培训予以记录。</el-col>
	                        <el-col :md="4">
	                            <el-form-item prop="moralCompliance.antiCorruptionTraining">
	                                <el-radio v-model="data.moralCompliance.antiCorruptionTraining" label="1">是</el-radio>
	                                <el-radio v-model="data.moralCompliance.antiCorruptionTraining" label="2">否</el-radio>
	                            </el-form-item>
	                        </el-col>
	                    </el-row>
	                    <el-row :gutter="10">
	                        <el-col :md="20">公司最近五年是否有操纵市场价格行为？</el-col>
	                        <el-col :md="4">
	                            <el-form-item prop="moralCompliance.manipulatingMarketPrices">
	                                <el-radio v-model="data.moralCompliance.manipulatingMarketPrices" label="1">是</el-radio>
	                                <el-radio v-model="data.moralCompliance.manipulatingMarketPrices" label="2">否</el-radio>
	                            </el-form-item>
	                        </el-col>
	                    </el-row>
	                    <el-row :gutter="10">
	                        <el-col :md="20">公司最近五年是否有不道德商业欺诈行为？</el-col>
	                        <el-col :md="4">
	                            <el-form-item prop="moralCompliance.commercialFraud">
	                                <el-radio v-model="data.moralCompliance.commercialFraud" label="1">是</el-radio>
	                                <el-radio v-model="data.moralCompliance.commercialFraud" label="2">否</el-radio>
	                            </el-form-item>
	                        </el-col>
	                    </el-row>
	                    <el-row :gutter="10">
	                        <el-col :md="20">公司最近五年是否有舞弊行为？</el-col>
	                        <el-col :md="4">
	                            <el-form-item prop="moralCompliance.fraudulentPractices">
	                                <el-radio v-model="data.moralCompliance.fraudulentPractices" label="1">是</el-radio>
	                                <el-radio v-model="data.moralCompliance.fraudulentPractices" label="2">否</el-radio>
	                            </el-form-item>
	                        </el-col>
	                    </el-row>
	                    <el-row :gutter="10">
	                        <el-col :md="20">公司最近五年是否有对销售产品不负责任的现象？</el-col>
	                        <el-col :md="4">
	                            <el-form-item prop="moralCompliance.irresponsiblePhenomena">
	                                <el-radio v-model="data.moralCompliance.irresponsiblePhenomena" label="1">是</el-radio>
	                                <el-radio v-model="data.moralCompliance.irresponsiblePhenomena" label="2">否</el-radio>
	                            </el-form-item>
	                        </el-col>
	                    </el-row>
	                </div><hr><br>
	                <div class="companyBaseInfoBox">
	                    <h5>企业诚信合规</h5><br>
	                    <el-row :gutter="10">
	                        <el-col :md="20">公司最近五年是否申请过破产？</el-col>
	                        <el-col :md="4">
	                            <el-form-item prop="enterpriseCreditCompliance.applyingForBankruptcy">
	                                <el-radio v-model="data.enterpriseCreditCompliance.applyingForBankruptcy" label="1">是</el-radio>
	                                <el-radio v-model="data.enterpriseCreditCompliance.applyingForBankruptcy" label="2">否</el-radio>
	                            </el-form-item>
	                        </el-col>
	                    </el-row>
	                    <el-row :gutter="10">
	                        <el-col :md="20">公司最近五年是否受过或可能会受到行政机关（如工商管理部门或税务部门）行政处分/处罚？</el-col>
	                        <el-col :md="4">
	                            <el-form-item prop="enterpriseCreditCompliance.administrativeSanction">
	                                <el-radio v-model="data.enterpriseCreditCompliance.administrativeSanction" label="1">是</el-radio>
	                                <el-radio v-model="data.enterpriseCreditCompliance.administrativeSanction" label="2">否</el-radio>
	                            </el-form-item>
	                        </el-col>
	                    </el-row>
	                    <el-row :gutter="10">
	                        <el-col :md="20">公司或主要管理人员在最近五年是否受过政府部门调查或制裁？</el-col>
	                        <el-col :md="4">
	                            <el-form-item prop="enterpriseCreditCompliance.governmentDepartmentSurvey">
	                                <el-radio v-model="data.enterpriseCreditCompliance.governmentDepartmentSurvey" label="1">是</el-radio>
	                                <el-radio v-model="data.enterpriseCreditCompliance.governmentDepartmentSurvey" label="2">否</el-radio>
	                            </el-form-item>
	                        </el-col>
	                    </el-row>
	                    <el-row :gutter="10">
	                        <el-col :md="20">公司或主要管理人员最近五年是否被法院纳入失信被执行人名单、受限制被执行人名单？</el-col>
	                        <el-col :md="4">
	                            <el-form-item prop="enterpriseCreditCompliance.discredit">
	                                <el-radio v-model="data.enterpriseCreditCompliance.discredit" label="1">是</el-radio>
	                                <el-radio v-model="data.enterpriseCreditCompliance.discredit" label="2">否</el-radio>
	                            </el-form-item>
	                        </el-col>
	                    </el-row>
	                    <el-row :gutter="10">
	                        <el-col :md="20">公司或主要管理人员最近五年是否存在或将要被限制进出口？</el-col>
	                        <el-col :md="4">
	                            <el-form-item prop="enterpriseCreditCompliance.restraintOnExportAndImport">
	                                <el-radio v-model="data.enterpriseCreditCompliance.restraintOnExportAndImport" label="1">是</el-radio>
	                                <el-radio v-model="data.enterpriseCreditCompliance.restraintOnExportAndImport" label="2">否</el-radio>
	                            </el-form-item>
	                        </el-col>
	                    </el-row>
	                    <el-row :gutter="10">
	                        <el-col :md="20">公司或主要管理人员是否曾经被控告或定罪或处罚或判刑（包括但不限于进出口、贿赂、关税、反垄断竞争、非法经营等）？</el-col>
	                        <el-col :md="4">
	                            <el-form-item prop="enterpriseCreditCompliance.accusedOrConvicted">
	                                <el-radio v-model="data.enterpriseCreditCompliance.accusedOrConvicted" label="1">是</el-radio>
	                                <el-radio v-model="data.enterpriseCreditCompliance.accusedOrConvicted" label="2">否</el-radio>
	                            </el-form-item>
	                        </el-col>
	                    </el-row>
	                    <el-row :gutter="10">
	                        <el-col :md="20">公司主要管理人员是否曾经或现在在政府部门中担任职务+A17:A41</el-col>
	                        <el-col :md="4">
	                            <el-form-item prop="enterpriseCreditCompliance.governmentDepartmentsHoldPositions">
	                                <el-radio v-model="data.enterpriseCreditCompliance.governmentDepartmentsHoldPositions" label="1">是</el-radio>
	                                <el-radio v-model="data.enterpriseCreditCompliance.governmentDepartmentsHoldPositions" label="2">否</el-radio>
	                            </el-form-item>
	                        </el-col>
	                    </el-row>
	                    <el-row :gutter="10">
	                        <el-col :md="20">公司主要管理人员是否同时服务于本公司以外的机构？</el-col>
	                        <el-col :md="4">
	                            <el-form-item prop="enterpriseCreditCompliance.serveOrganizationsOthers">
	                                <el-radio v-model="data.enterpriseCreditCompliance.serveOrganizationsOthers" label="1">是</el-radio>
	                                <el-radio v-model="data.enterpriseCreditCompliance.serveOrganizationsOthers" label="2">否</el-radio>
	                            </el-form-item>
	                        </el-col>
	                    </el-row>
	                    <el-row :gutter="10">
	                        <el-col :md="20">公司最近五年是否被取消过提供经销及服务的授权或被拒绝更新提供经销或服务授权？</el-col>
	                        <el-col :md="4">
	                            <el-form-item prop="enterpriseCreditCompliance.cancellationOfOfferedDistribution">
	                                <el-radio v-model="data.enterpriseCreditCompliance.cancellationOfOfferedDistribution" label="1">是</el-radio>
	                                <el-radio v-model="data.enterpriseCreditCompliance.cancellationOfOfferedDistribution" label="2">否</el-radio>
	                            </el-form-item>
	                        </el-col>
	                    </el-row>
	                    <el-row :gutter="10">
	                        <el-col :md="20">公司最近五年是否存在已完结的或悬而未决的诉讼、仲裁、行政处罚案件？</el-col>
	                        <el-col :md="4">
	                            <el-form-item prop="enterpriseCreditCompliance.isThereCase">
	                                <el-radio v-model="data.enterpriseCreditCompliance.isThereCase" label="1">是</el-radio>
	                                <el-radio v-model="data.enterpriseCreditCompliance.isThereCase" label="2">否</el-radio>
	                            </el-form-item>
	                        </el-col>
	                    </el-row>
	                </div><hr><br>
	                <div>
	                    <el-row :gutter="10">
	                        <el-col :md="8">备注说明：</el-col>
	                        <el-col :md="16">
	                            <el-form-item prop="epilogue.remarks">
	                                <el-input type="textarea" 
	                                    v-model="data.epilogue.remarks"></el-input>
	                            </el-form-item>
	                        </el-col>
	                    </el-row>
	                    <el-row :gutter="10">
	                        <el-col :md="8">问卷填写日期：</el-col>
	                        <el-col :md="16">
	                            <el-form-item prop="epilogue.writeDate">
	                                <el-date-picker
	                                    readonly
	                                    v-model="data.epilogue.writeDate"
	                                    type="date"
	                                    placeholder="选择日期">
	                                </el-date-picker>
	                            </el-form-item>
	                        </el-col>
	                    </el-row>
	                    <el-row :gutter="10">
	                        <el-col :md="8">填写人姓名：</el-col>
	                        <el-col :md="16">
	                            <el-form-item prop="epilogue.writer">
	                                <el-input placeholder="填写人姓名"
	                                    v-model="data.epilogue.writer"></el-input>
	                            </el-form-item>
	                        </el-col>
	                    </el-row>
	                    <el-row :gutter="10">
	                        <el-col :md="8">职位：</el-col>
	                        <el-col :md="16">
	                            <el-form-item prop="epilogue.position">
	                                <el-input placeholder="职位"
	                                    v-model="data.epilogue.position"></el-input>
	                            </el-form-item>
	                        </el-col>
	                    </el-row>
	                    <el-row :gutter="10">
	                        <el-col :md="8">联系电话：</el-col>
	                        <el-col :md="16">
	                            <el-form-item prop="epilogue.tel">
	                                <el-input placeholder="联系电话"
	                                    v-model="data.epilogue.tel"></el-input>
	                            </el-form-item>
	                        </el-col>
	                    </el-row>
	                    <el-row :gutter="10">
	                        <el-col :md="8">电子邮箱：</el-col>
	                        <el-col :md="16">
	                            <el-form-item prop="epilogue.email">
	                                <el-input placeholder="电子邮箱"
	                                    v-model="data.epilogue.email"></el-input>
	                            </el-form-item>
	                        </el-col>
	                    </el-row>
	                </div>
	            </el-form>
	        </div><br>
	    </div>
	    <div :class="{'dispear': active!==2?true:false}">
	    	<div class="btnBox">
	    		<div>
	    			<span style="line-height:32px;">生成一代渠道商并将数据同步至PMS&nbsp;&nbsp;</span>
		    	</div>
	        	<el-button @click="submitFirstChannel" type="primary">确认提交</el-button>
	    	</div>
        </div>
        <el-dialog title="进程提示框" :visible.sync="processVisible" width="30%">
            <span>正在执行中，请稍候......</span>
         </el-dialog>
	</div>
</template>
<script type="text/javascript">
	var regionsData = require('../../../data/regions.json');
	export default {
        data() {
            return {
            	processVisible:false,
            	active:0,
            	firstVisible:false,
				secondeVisible:true,
                fileUploadWeb: '/api/workOriginator/uploadFile',
                regions:regionsData.regions,
                performanceAccountingCitySecondRegions:{},
                taxpayerTypeList:[
                    '一般纳税人',
                    '小额纳税人'
                ],
                integrateQualificationsList:[
                    '无',
                    '四级',
                    '三级',
                    '二级',
                    '一级',
                ],
                subordinateOfficesList:[
                    '行业渠道总部'
                ],
                rules:{
                    baseInfo:{
                        legalNamelegalName:[
                            { required: true, message: '请输入法定名称', trigger: 'blur' },
                        ],
                        performanceAccountingCity:[
                            { required: true, message: '请选择业绩核算城市', trigger: 'change' }
                        ],
                        performanceAccountingProvince:[
                            { required: true, message: '请选择业绩核算城市', trigger: 'change' }
                        ],
                        registeredCapital:[
                            { required: true, message: '请输入注册资金', trigger: 'blur' },
                        ],
                        establishmentTime:[
                            { required: true, message: '请输入成立时间', trigger: 'change' },
                        ],
                        taxID:[
                            { required: true, message: '请输入税务登记号', trigger: 'blur' },
                        ],
                        applicationTime:[
                            { required: true, message: '请输入申请时间', trigger: 'change' },
                        ],
                        taxpayerType:[
                            { required: true, message: '请输入纳税人类别', trigger: 'change' },
                        ],
                        integrateQualifications:[
                            { required: true, message: '请输入信产部系统集成商资质', trigger: 'change' },
                        ],
                        currentProvice:[
                            { required: true, message: '请输入所在省份', trigger: 'change' },
                        ],
                        subordinateOffices:[
                            { required: true, message: '请输入所属办事处', trigger: 'change' },
                        ],
                        switchboard:[
                            { required: true, message: '请输入总机', trigger: 'blur' },
                        ],
                        fax:[
                            { required: true, message: '请输入传真', trigger: 'blur' },
                        ],
                        zipCode:[
                            { required: true, message: '请输入邮编', trigger: 'blur' },
                        ],
                        mailingAddress:[
                            { required: true, message: '请输入邮寄地址', trigger: 'blur' },
                        ],

                    },
                    contactInfo:{
                        corporateRepresentative:{   //法人代表
                            name:[
                                { required: true, message: '请输入姓名', trigger: 'blur' },
                            ],    //姓名
                            phone:[
                                { required: true, message: '请输入电话', trigger: 'blur' },
                            ],   //电话
                            tel:[
                                { required: true, message: '请输入手机', trigger: 'blur' },
                            ],     //手机
                            email:[
                                { required: true, message: '请输入邮箱', trigger: 'blur' },
                            ],   //邮箱
                        },
                        generalManager:{    //总经理
                            name:[
                                { required: true, message: '请输入姓名', trigger: 'blur' },
                            ],    //姓名
                            phone:[
                                { required: true, message: '请输入电话', trigger: 'blur' },
                            ],   //电话
                            tel:[
                                { required: true, message: '请输入手机', trigger: 'blur' },
                            ],     //手机
                            email:[
                                { required: true, message: '请输入邮箱', trigger: 'blur' },
                            ],   //邮箱
                        },
                        salesPersonInCharge:{   //销售负责人：
                            job:[
                                { required: true, message: '请输入职务', trigger: 'blur' },
                            ],     //职务
                            name:[
                                { required: true, message: '请输入姓名', trigger: 'blur' },
                            ],    //姓名
                            phone:[
                                { required: true, message: '请输入电话', trigger: 'blur' },
                            ],   //电话
                            tel:[
                                { required: true, message: '请输入手机', trigger: 'blur' },
                            ],     //手机
                            email:[
                                { required: true, message: '请输入邮箱', trigger: 'blur' },
                            ],   //邮箱
                        },
                        publicityOfficer:{  //宣传负责人：
                            job:[
                                { required: true, message: '请输入职务', trigger: 'blur' },
                            ],     //职务
                            name:[
                                { required: true, message: '请输入姓名', trigger: 'blur' },
                            ],    //姓名
                            phone:[
                                { required: true, message: '请输入电话', trigger: 'blur' },
                            ],   //电话
                            tel:[
                                { required: true, message: '请输入手机', trigger: 'blur' },
                            ],     //手机
                            email:[
                                { required: true, message: '请输入邮箱', trigger: 'blur' },
                            ],   //邮箱
                        },
                        businessPersonInCharge:{    //商务负责人：
                            job:[
                                { required: true, message: '请输入职务', trigger: 'blur' },
                            ],     //职务
                            name:[
                                { required: true, message: '请输入姓名', trigger: 'blur' },
                            ],    //姓名
                            phone:[
                                { required: true, message: '请输入电话', trigger: 'blur' },
                            ],   //电话
                            tel:[
                                { required: true, message: '请输入手机', trigger: 'blur' },
                            ],     //手机
                            email:[
                                { required: true, message: '请输入邮箱', trigger: 'blur' },
                            ],   //邮箱
                        },
                        technicalClothingPersonInCharge:{   //技服负责人
                            job:[
                                { required: true, message: '请输入职务', trigger: 'blur' },
                            ],     //职务
                            name:[
                                { required: true, message: '请输入姓名', trigger: 'blur' },
                            ],    //姓名
                            phone:[
                                { required: true, message: '请输入电话', trigger: 'blur' },
                            ],   //电话
                            tel:[
                                { required: true, message: '请输入手机', trigger: 'blur' },
                            ],     //手机
                            email:[
                                { required: true, message: '请输入邮箱', trigger: 'blur' },
                            ],   //邮箱
                        },
                        orderNotificationReceiver:{ //订单通知单接收人
                            job:[
                                { required: true, message: '请输入职务', trigger: 'blur' },
                            ],     //职务
                            name:[
                                { required: true, message: '请输入姓名', trigger: 'blur' },
                            ],    //姓名
                            phone:[
                                { required: true, message: '请输入电话', trigger: 'blur' },
                            ],   //电话
                            tel:[
                                { required: true, message: '请输入手机', trigger: 'blur' },
                            ],     //手机
                            email:[
                                { required: true, message: '请输入邮箱', trigger: 'blur' },
                            ],   //邮箱
                        },
                        dailyContactPerson :{   //日常联络人
                            job:[
                                { required: true, message: '请输入职务', trigger: 'blur' },
                            ],     //职务
                            name:[
                                { required: true, message: '请输入姓名', trigger: 'blur' },
                            ],    //姓名
                            phone:[
                                { required: true, message: '请输入电话', trigger: 'blur' },
                            ],   //电话
                            tel:[
                                { required: true, message: '请输入手机', trigger: 'blur' },
                            ],     //手机
                            email:[
                                { required: true, message: '请输入邮箱', trigger: 'blur' },
                            ],   //邮箱
                        },
                    },
                    h3cContactInfo:{
                        office:[
                                { required: true, message: '请输入办事处', trigger: 'change' },
                            ],      //办事处
                        name:[
                                { required: true, message: '请输入姓名', trigger: 'blur' },
                            ],    //姓名
                        phone:[
                                { required: true, message: '请输入电话', trigger: 'blur' },
                            ],   //电话
                        tel:[
                                { required: true, message: '请输入手机', trigger: 'blur' },
                            ],     //手机
                        email:[
                                { required: true, message: '请输入邮箱', trigger: 'blur' },
                            ],   //邮箱
                    },
                    fileNames:{
                        businessLicense:{
                            newFileName:[
                                {required: true, message: '请上传文件', trigger: 'blur'}
                            ]
                        }
                    }
                },
                formData:{
                    baseInfo:{
                        legalNamelegalName:'',  // 法定名称
                        performanceAccountingCity:'',   //业绩核算-市
                        performanceAccountingProvince:'',    //业绩核算-省
                        registeredCapital:'',   // 注册资金
                        establishmentTime:'',   // 成立时间
                        taxID:'',   // 税务登记号
                        applicationTime:'',     // 申请时间
                        taxpayerType:'一般纳税人',    // 纳税人类别
                        integrateQualifications:'无', // 信产部系统集成商资质
                        currentProvice:'',  // 所在省份
                        subordinateOffices:'行业渠道总部',  // 所属办事处
                        switchboard:'', // 总机
                        fax:'',     // 传真
                        zipCode:'', // 邮编
                        mailingAddress:'', //   邮寄地址
                        webAddress:'',  //网址
                        businessIntroduction: '', //业务介绍
                    },
                    contactInfo:{
                        corporateRepresentative:{   //法人代表
                            name:'',    //姓名
                            phone:'',   //电话
                            tel:'',     //手机
                            email:'',   //邮箱
                        },
                        generalManager:{    //总经理
                            name:'',    //姓名
                            phone:'',   //电话
                            tel:'',     //手机
                            email:'',   //邮箱
                        },
                        salesPersonInCharge:{   //销售负责人：
                            job:'',     //职务
                            name:'',    //姓名
                            phone:'',   //电话
                            tel:'',     //手机
                            email:'',   //邮箱
                        },
                        publicityOfficer:{  //宣传负责人：
                            job:'',     //职务
                            name:'',    //姓名
                            phone:'',   //电话
                            tel:'',     //手机
                            email:'',   //邮箱
                        },
                        businessPersonInCharge:{    //商务负责人：
                            job:'',     //职务
                            name:'',    //姓名
                            phone:'',   //电话
                            tel:'',     //手机
                            email:'',   //邮箱
                        },
                        technicalClothingPersonInCharge:{   //技服负责人
                            job:'',     //职务
                            name:'',    //姓名
                            phone:'',   //电话
                            tel:'',     //手机
                            email:'',   //邮箱
                        },
                        orderNotificationReceiver:{ //订单通知单接收人
                            job:'',     //职务
                            name:'',    //姓名
                            phone:'',   //电话
                            tel:'',     //手机
                            email:'',   //邮箱
                        },
                        dailyContactPerson :{   //日常联络人
                            job:'',     //职务
                            name:'',    //姓名
                            phone:'',   //电话
                            tel:'',     //手机
                            email:'',   //邮箱
                        },
                    },
                    h3cContactInfo:{
                        office:'',
                        name:'',    //姓名
                        phone:'',   //电话
                        tel:'',     //手机
                        email:'',   //邮箱
                    },
                    fileNames:{
                        businessLicense:{
                            fileName:'',
                            newFileName:'',
                            filePath:'',
                        }, // 营业执照
                        openBankAccountPermitCertificate:{
                            fileName:'',
                            newFileName:'',
                            filePath:'',
                        },    // 银行开户许可证
                        copyOfIDCard:{
                            fileName:'',
                            newFileName:'',
                            filePath:'',
                        },    //法人身份证复印件
                        integratedQualificationCertificate:{
                            fileName:'',
                            newFileName:'',
                            filePath:'',
                        }, //信产部系统集成资质证书
                        capitalVerificationReport:{
                            fileName:'',
                            newFileName:'',
                            filePath:'',
                        },   //验资报告或财务审计报告
                        others:{
                            fileName:'',
                            newFileName:'',
                            filePath:'',
                        },//其他
                    }
                },
	            id:'',
	            data:{
	                companyBaseInfo:{
	                    corporateName:'',
	                    unifiedSocialCreditCode:'',
	                    registeredAddress:'',
	                    actualBusinessAddress:'',
	                    companyOfficialWebsiteAddress:'',
	                    legalRepresentative:'',
	                    generalManager:'',
	                    salesDirector:'',
	                    OtherKeyManagers:'',
	                },
	                laborCompliance:{
	                    totalNumberOfEmployees:'',
	                    childLabourExists:'1',
	                    buyingSocialInsurance:'1',
	                    mandatoryOvertimeWork:'1',
	                    deprivationOfStaff:'1',
	                },
	                companySalesCompliance:{
	                    companySalesArea:'1',
	                    salesBrief:'',
	                    isTheCompanyLegal:'1',
	                    isTheCompanyQualified:'1',
	                    isTheCompanyLicense:'1',
	                    secondaryAgency:'1',
	                },
	                moralCompliance:{
	                    commercialBribery:'1',
	                    corruptionPhenomenon:'1',
	                    antiCorruptionTraining:'1',
	                    manipulatingMarketPrices:'1',
	                    commercialFraud:'1',
	                    fraudulentPractices:'1',
	                    irresponsiblePhenomena:'1',
	                },
	                enterpriseCreditCompliance:{
	                    applyingForBankruptcy:'1',
	                    administrativeSanction:'1',
	                    governmentDepartmentSurvey:'1',
	                    discredit:'1',
	                    restraintOnExportAndImport:'1',
	                    accusedOrConvicted:'1',
	                    governmentDepartmentsHoldPositions:'1',
	                    serveOrganizationsOthers:'1',
	                    cancellationOfOfferedDistribution:'1',
	                    isThereCase:'1',
	                },
	                epilogue:{
	                    remarks:'',
	                    writeDate:'',
	                    writer:'',
	                    position:'',
	                    tel:'',
	                    email:'',
	                }
	            },
	            qRules:{
	                companyBaseInfo:{
	                    corporateName:[
	                        { required: true, message: '该项不能为空',trigger: 'blur' },
	                    ],
	                    unifiedSocialCreditCode:[
	                        { required: true, message: '该项不能为空',trigger: 'blur' },
	                    ],
	                    registeredAddress:[
	                        { required: true, message: '该项不能为空',trigger: 'blur' },
	                    ],
	                    actualBusinessAddress:[
	                        { required: true, message: '该项不能为空',trigger: 'blur' },
	                    ],
	                    companyOfficialWebsiteAddress:[
	                        { required: true, message: '该项不能为空',trigger: 'blur' },
	                    ],
	                    legalRepresentative:[
	                        { required: true, message: '该项不能为空',trigger: 'blur' },
	                    ],
	                    generalManager:[
	                        { required: true, message: '该项不能为空',trigger: 'blur' },
	                    ],
	                    salesDirector:[
	                        { required: true, message: '该项不能为空',trigger: 'blur' },
	                    ],
	                    OtherKeyManagers:[
	                        { required: true, message: '该项不能为空',trigger: 'blur' },
	                    ],
	                },
	                laborCompliance:{
	                    totalNumberOfEmployees:[
	                        { required: true, message: '该项不能为空',trigger: 'blur' },
	                    ],
	                    childLabourExists:[
	                        { required: true, message: '该项不能为空',trigger: 'blur' },
	                    ],
	                    buyingSocialInsurance:[
	                        { required: true, message: '该项不能为空',trigger: 'blur' },
	                    ],
	                    mandatoryOvertimeWork:[
	                        { required: true, message: '该项不能为空',trigger: 'blur' },
	                    ],
	                    deprivationOfStaff:[
	                        { required: true, message: '该项不能为空',trigger: 'blur' },
	                    ],
	                },
	                companySalesCompliance:{
	                    companySalesArea:[
	                        { required: true, message: '该项不能为空',trigger: 'blur' },
	                    ],
	                    salesBrief:[
	                        { required: true, message: '该项不能为空',trigger: 'blur' },
	                    ],
	                    isTheCompanyLegal:[
	                        { required: true, message: '该项不能为空',trigger: 'blur' },
	                    ],
	                    isTheCompanyQualified:[
	                        { required: true, message: '该项不能为空',trigger: 'blur' },
	                    ],
	                    isTheCompanyLicense:[
	                        { required: true, message: '该项不能为空',trigger: 'blur' },
	                    ],
	                    secondaryAgency:[
	                        { required: true, message: '该项不能为空',trigger: 'blur' },
	                    ],
	                },
	                moralCompliance:{
	                    commercialBribery:[
	                        { required: true, message: '该项不能为空',trigger: 'blur' },
	                    ],
	                    corruptionPhenomenon:[
	                        { required: true, message: '该项不能为空',trigger: 'blur' },
	                    ],
	                    antiCorruptionTraining:[
	                        { required: true, message: '该项不能为空',trigger: 'blur' },
	                    ],
	                    manipulatingMarketPrices:[
	                        { required: true, message: '该项不能为空',trigger: 'blur' },
	                    ],
	                    commercialFraud:[
	                        { required: true, message: '该项不能为空',trigger: 'blur' },
	                    ],
	                    fraudulentPractices:[
	                        { required: true, message: '该项不能为空',trigger: 'blur' },
	                    ],
	                    irresponsiblePhenomena:[
	                        { required: true, message: '该项不能为空',trigger: 'blur' },
	                    ],
	                },
	                enterpriseCreditCompliance:{
	                    applyingForBankruptcy:[
	                        { required: true, message: '该项不能为空',trigger: 'blur' },
	                    ],
	                    administrativeSanction:[
	                        { required: true, message: '该项不能为空',trigger: 'blur' },
	                    ],
	                    governmentDepartmentSurvey:[
	                        { required: true, message: '该项不能为空',trigger: 'blur' },
	                    ],
	                    discredit:[
	                        { required: true, message: '该项不能为空',trigger: 'blur' },
	                    ],
	                    restraintOnExportAndImport:[
	                        { required: true, message: '该项不能为空',trigger: 'blur' },
	                    ],
	                    accusedOrConvicted:[
	                        { required: true, message: '该项不能为空',trigger: 'blur' },
	                    ],
	                    governmentDepartmentsHoldPositions:[
	                        { required: true, message: '该项不能为空',trigger: 'blur' },
	                    ],
	                    serveOrganizationsOthers:[
	                        { required: true, message: '该项不能为空',trigger: 'blur' },
	                    ],
	                    cancellationOfOfferedDistribution:[
	                        { required: true, message: '该项不能为空',trigger: 'blur' },
	                    ],
	                    isThereCase:[
	                        { required: true, message: '该项不能为空',trigger: 'blur' },
	                    ],
	                },
	                epilogue:{
	                    remarks:[
	                        { required: true, message: '该项不能为空',trigger: 'blur' },
	                    ],
	                    writeDate:[
	                        { required: true, message: '该项不能为空',trigger: 'blur' },
	                    ],
	                    writer:[
	                        { required: true, message: '该项不能为空',trigger: 'blur' },
	                    ],
	                    position:[
	                        { required: true, message: '该项不能为空',trigger: 'blur' },
	                    ],
	                    tel:[
	                        { required: true, message: '该项不能为空',trigger: 'blur' },
	                    ],
	                    email:[
	                        { required: true, message: '该项不能为空',trigger: 'blur' },
	                    ],
	                }
	            },
	        }
        },
        created(){
            this.initCurrentDate();            
        },
        methods:{
	        performanceAccountingProvinceChange(provinceStr){
	            this.formData.baseInfo.performanceAccountingCity = '';
	            if(!(this.performanceAccountingCitySecondRegions.length==null || this.performanceAccountingCitySecondRegions.length==undefined || this.performanceAccountingCitySecondRegions.length==0)){
	                this.performanceAccountingCitySecondRegions.slice(0,this.performanceAccountingCitySecondRegions.length);
	            }
	            var r = {};
	            for(var item in this.regions){ 
	                if(this.regions[item].name==provinceStr){ 
	                    var r = this.regions[item].child;
	                } 
	            }  
	            this.performanceAccountingCitySecondRegions = r;
	        },
	        fileUploadBus(response, file, fileList){
	            if(response.code == 1){
	                this.formData.fileNames.businessLicense.fileName = response.data.fileName;
	                this.formData.fileNames.businessLicense.newFileName = response.data.newFileName;
	                this.formData.fileNames.businessLicense.filePath = response.data.filePath;
	            }
	        },
	        fileUploadOpe(response, file, fileList){
	            if(response.code == 1){
	                this.formData.fileNames.openBankAccountPermitCertificate.fileName = response.data.fileName;
	                this.formData.fileNames.openBankAccountPermitCertificate.newFileName = response.data.newFileName;
	                this.formData.fileNames.openBankAccountPermitCertificate.filePath = response.data.filePath;
	            }
	        },
	        fileUploadCop(response, file, fileList){
	            if(response.code == 1){
	                this.formData.fileNames.copyOfIDCard.fileName = response.data.fileName;
	                this.formData.fileNames.copyOfIDCard.newFileName = response.data.newFileName;
	                this.formData.fileNames.copyOfIDCard.filePath = response.data.filePath;
	            }
	        },
	        fileUploadInt(response, file, fileList){
	            if(response.code == 1){
	                this.formData.fileNames.integratedQualificationCertificate.fileName = response.data.fileName;
	                this.formData.fileNames.integratedQualificationCertificate.newFileName = response.data.newFileName;
	                this.formData.fileNames.integratedQualificationCertificate.filePath = response.data.filePath;
	            }
	        },
	        fileUploadCap(response, file, fileList){
	            if(response.code == 1){
	                this.formData.fileNames.capitalVerificationReport.fileName = response.data.fileName;
	                this.formData.fileNames.capitalVerificationReport.newFileName = response.data.newFileName;
	                this.formData.fileNames.capitalVerificationReport.filePath = response.data.filePath;
	            }
	        },
	        fileUploadOth(response, file, fileList){
	            if(response.code == 1){
	                this.formData.fileNames.others.fileName = response.data.fileName;
	                this.formData.fileNames.others.newFileName = response.data.newFileName;
	                this.formData.fileNames.others.filePath = response.data.filePath;
	            }
	        },
	        initCurrentDate(){
	            let date = new Date();
	            let dateStr = this.$tools.utcToGmt(date);
	            this.data.epilogue.writeDate = dateStr;
	        },
	        next() {
	        	if(this.active + 1 >2){
	        		this.active = 0
	        	}else{
	        		this.active = this.active + 1 ;
	        	}
				console.log("active:"+this.active)
				switch(this.active){
					case 0: 
						this.firstVisible = false;
						this.secondeVisible = true;
						break;
					case 1:
						this.firstVisible = true;
						this.secondeVisible = false;
						break;
					case 2:
						this.firstVisible = true;
						this.secondeVisible = true;
						break;
				}
				console.log("first:"+this.firstVisible+";seconde"+this.secondeVisible);
			},
			submitFirstChannel(){
				//校验基础资料
				this.$refs['ruleForm'].validate((valid) => {
                    if (valid) {
                    	//校验合规问卷
                    	this.$refs['ruleForm'].validate((valid) => {
                    		if (valid) {
                    			this.processVisible = true;
                    			this.$axios({
		                            method:'post',
		                            url:'/api/workAdmin/createFirstChannel',
		                            withCredentials:true,
		                            data: this.$qs.stringify({
		                                formData:JSON.stringify(this.formData),
                                		questionnaireInfo:JSON.stringify(this.data),
		                            })
		                        }).then((response) =>{          //这里使用了ES6的语法
		                            if(response.data.code == 1){
		                                this.$message.success(`创建成功`);
		                                this.$router.push('/work/channel');    
		                            }else{
		                                this.$message.warning(response.data.message);
		                            }
		                        }).catch((error) =>{
		                            this.$message.error(`创建失败`);
		                            console.log(error)       //请求失败返回的数据
		                        }).finally(()=>{
				                    this.processVisible = false;
				                });
                    		}else{
                    			this.$message('合规问卷中有必填项未填写，请填写完毕后再提交');
                    		}
                    	});
                    }else{
                    	this.$message('基础资料中有必填项未填写，请填写完毕后再提交');
                    }
                });
			}
		},
    }
</script>
<style type="text/css">
	.dispear{
		display: none;
	}
	.dataFillContainer{
        width: 100%;
    }
    .baseInfoBox{
        margin: 0 auto;
        /*margin-top:30px;*/
        width:1000px;
        padding:30px 0;
        padding-top: 0;
    }
    .contactInfoBox{
        margin: 0 auto;
        margin-top:30px;
        width:1000px;
        padding:30px 0;
    }
    .h3cContactInfoBox{
        margin: 0 auto;
        margin-top:30px;
        width:1000px;
        padding:30px 0;
    }
    .fileUploadInfoBox{
        margin: 0 auto;
        margin-top:30px;
        width:1000px;
        padding:30px 0;
    }
    .buttonBox{
        text-align: center;
        margin: 30px auto;
        margin-top:0;
        width:1000px;
    }
    .el-upload--text{
        height:30px;
        background-color: transparent;
        border: 0px;
    }
    .el-row{
        margin-top:6px;
    }
    .questionnaireContainer{
        margin: 0 auto;
        /*margin-top:30px;*/
        width:1000px;
        padding:30px 0;
        padding-top:0;
    }
    .buttonBox{
        text-align: center;
        margin: 30px auto;
        margin-top:0;
        width:1000px;
    }
    .stepClass{
		margin: 0 auto;
	    margin-top: 30px;
	    width: 100%;
	    padding: 30px 20px;
	    border: 4px dashed #aaa;
	    border-radius: 10px;
    }
    .btnBox{
	    width: 100%;
	    margin: 0 auto;
	    display: flex;
	    justify-content: center;
	    flex-direction: row;
	    padding-top: 140px;
    }
</style>